import React from "react";
import { Page } from "../../activities/AppPage";
import { API } from "../../API";
import { isLoading, Loading } from "../../Loading";
import { STRINGS } from "../../strings";
import { AppCaregiver } from "../../system/AppState/AppCaregiverState";
import { translate } from "../../translate";
import LoadingScaffold from "../LoadingScaffold";
import analyticsUtils from "./../../utils/analyticsUtils";
import AwardsComingSoonModal from "./AwardsComingSoonModal";
import CarebackPointsScreen from "./CarebackPointsScreen";

interface Props {
  api: API;
  caregiver: AppCaregiver | Loading;
  onClickGoBack: () => void;
  onRequestNavigate: (page: Page) => void;
}

const CarebackPointsActivity = (props: Props) => {
  const [isModalOpen, setModalOpen] = React.useState(false);

  const handleClickGetNow = (reward: string) => {
    analyticsUtils.track(`clicked get now ${reward}`);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  if (isLoading(props.caregiver)) {
    return (
      <LoadingScaffold
        title={translate(STRINGS.POINTS_AND_REWARDS)}
        onClickGoBack={props.onClickGoBack}
      />
    );
  }

  return (
    <>
      <CarebackPointsScreen
        caregiverPoints={props.caregiver.points}
        onClickGoBack={props.onClickGoBack}
        onClickGetNow={handleClickGetNow}
      />
      <AwardsComingSoonModal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
      ></AwardsComingSoonModal>
    </>
  );
};

export default CarebackPointsActivity;
